import { Link, useHistory } from "react-router-dom";
import editIcon from "../assets/img/edit-icon.svg";
import { AppRouteUi } from "../config/appRoute";
import { Card } from "./card.component";
import { SpinLoader } from "./spinLoader.component";

type Props = {
  title: string;
  changePassword?: boolean;
  isValidating?: boolean;
  showLoader?: boolean;
  children: string | JSX.Element;
  link?: string;
  className?: string;
  showEditButton?: boolean;
  showBackButton?: boolean;
};

export const EditableCard = (props: Props) => {
  const routeHistory = useHistory();
  return (
    <Card
      className={props.className}
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col content-box-title">
            <div className="d-flex align-items-center">
              {props.showBackButton && (
                <div
                  onClick={() => {
                    routeHistory.length > 1
                      ? routeHistory.goBack()
                      : routeHistory.push(AppRouteUi.Root);
                  }}
                  className="pe-2 me-2 border-2 border-end click text-green-200"
                >
                  <i className="fas fa-arrow-left text-green-200" />
                </div>
              )}
              <p className="text-capitalize mb-0 text-green-200">
                {props.title}
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
          <div className="col-6 text-end d-flex flex-row-reverse">
            {props.changePassword && (
              <Link
                to={{
                  pathname: AppRouteUi.Settings.Root(),
                  state: { expanded: "password" },
                }}
                className="text-green-200 me-4 text-decoration-none"
              >
                Change Password
              </Link>
            )}
            {props.showEditButton && (
              <Link
                to={props.link || "#"}
                className="text-black text-decoration-none"
              >
                <img
                  src={editIcon}
                  alt="Uploaded Item"
                  className="me-2"
                  height={15}
                />
                Edit
              </Link>
            )}
          </div>
        </div>
      }
    >
      {props.showLoader && props.isValidating ? <SpinLoader /> : props.children}
    </Card>
  );
};
